import * as zod from 'zod';

export const JSRunnerData = zod.object({
  expression: zod.string(),
  context: zod.any().optional(),
  result: zod.unknown().optional(),
});

export type JSRunnerData = zod.infer<typeof JSRunnerData>;
